import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff',
    color: '#1a1a1a',
    fontFamily: 'Times-Roman',
    fontSize: 11,
    lineHeight: 1.6,
    padding: 30,
    boxSizing: 'border-box',
  },
  section: {
    marginBottom: 8,
    marginTop: 6,
    padding: 0,
  },
  subSection: {
    lineHeight: 1.5,
    marginTop: 3,
    marginBottom: 3,
    marginLeft: 20,
    fontWeight: 'bold',
    fontSize: 11,
    color: '#2c3e50',
  },
  header: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 5,
    color: '#1a365d',
    letterSpacing: 0.5,
  },
  title: {
    fontSize: 13,
    fontWeight: 'bold',
    marginBottom: 8,
    marginTop: 12,
    color: '#2d3748',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    paddingBottom: 3,
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 6,
    marginTop: 8,
    color: '#4a5568',
  },
  text: {
    fontSize: 12,
    marginBottom: 2,
    lineHeight: 1.6,
    color: '#000',
    textAlign: 'justify',
  },
  contractId: {
    fontSize: 9,
    color: '#718096',
    textAlign: 'center',
    marginTop: 2,
    marginBottom: 15,
    fontStyle: 'italic',
  },
  badge: {
    backgroundColor: '#2d3748',
    color: '#ffffff',
    padding: 6,
    fontSize: 9,
    textAlign: 'center',
    marginBottom: 20,
    borderRadius: 3,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  divider: {
    borderBottomWidth: 2,
    borderBottomColor: '#e2e8f0',
    marginTop: 15,
    marginBottom: 15,
  },
  bold: {
    fontWeight: 'bold',
    color: '#1a365d',
  },
  underline: {
    textDecoration: 'underline',
    textDecorationColor: '#3182ce',
  },
  marginBottom: {
    marginBottom: 20,
  },
  list: {
    marginLeft: 5,
    marginTop: 5,
    marginBottom: 5,
  },
  listItem: {
    fontSize: 12,
    marginBottom: 3,
    lineHeight: 1.4,
    color: '#000',
    marginLeft: 15,
    textAlign: 'justify',
  },
  InfoText: {
    fontWeight: 'bold',
    color: '#3182ce',
    textDecoration: 'underline',
    padding: 2,
    textTransform: 'capitalize',
  },
  DangerText: {
    fontWeight: 'bold',
    color: '#e53e3e',
    textDecoration: 'underline',
    padding: 2,
  },
  ClauseText: {
    fontWeight: 'bold',
    color: '#1a365d',
    fontSize: 11,
  },
  image: {
    width: 100,
    height: 100,
    marginBottom: 10,
  },
  // Professional contract styling
  contractHeader: {
    textAlign: 'center',
    marginBottom: 25,
    paddingBottom: 15,
    borderBottomWidth: 3,
    borderBottomColor: '#2d3748',
  },
  contractBody: {
    marginTop: 20,
  },
  numberedClause: {
    fontSize: 11,
    marginBottom: 8,
    lineHeight: 1.6,
    textAlign: 'justify',
    color: '#2d3748',
  },
  // Property details styling
  propertyDetails: {
    backgroundColor: '#f7fafc',
    padding: 12,
    marginTop: 8,
    marginBottom: 8,
    borderLeftWidth: 4,
    borderLeftColor: '#3182ce',
  },
  // Financial information styling
  financialInfo: {
    backgroundColor: '#f0fff4',
    padding: 10,
    marginTop: 6,
    marginBottom: 6,
    borderLeftWidth: 3,
    borderLeftColor: '#38a169',
  },
  // Legal text styling
  legalText: {
    fontSize: 10,
    color: '#4a5568',
    fontStyle: 'italic',
    marginTop: 5,
  },
  // Signature section styling
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    marginBottom: 20,
  },
  signatureColumn: {
    flex: 1,
    marginRight: 20,
  },
  signatureLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#2d3748',
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    paddingBottom: 5,
    marginBottom: 15,
  },
});
